import { AudioPlayer } from 'app/components/AudioPlayer';
import { EditHoldMusicDialogGroup } from 'app/components/EditHoldMusicDialogGroup';
import { useFindInPage } from 'app/components/FindInPage';
import { GenericSettingsCardField } from 'app/components/GenericSettingsCardField';
import { BUILT_IN_AUDIO } from 'app/components/MediaDialog/components/BuiltInAudio/BUILT_IN_AUDIO';
import { useToggleReducer } from 'app/utilities';
import { useMarkdownTranslate } from 'app/utilities/translate';
import { startCase } from 'lodash';
import * as React from 'react';
import { Group } from 'types/group';
import { Chip } from 'app/design';

interface GroupUsageProps {
  group: Group;
  onComplete: () => void;
}

const GroupHoldMusic = ({ group, onComplete }: GroupUsageProps) => {
  const [showEditDialog, toggleShowEditDialog] = useToggleReducer(false);
  const { ref, HighlightPulse, highlightPulseProps } = useFindInPage({
    name: 'holdMusic',
    options: [
      {
        label: 'Hold Music',
        value: 'holdMusic',
      },
    ],
    onChoose: 'matchAnyScrollToRef',
  });

  const handleOnComplete = () => {
    onComplete();
    toggleShowEditDialog();
  };

  const mediaId = group.HoldMusic?.id;

  const { t } = useMarkdownTranslate();

  return (
    // @ts-ignore
    <div ref={ref}>
      {showEditDialog ? (
        <EditHoldMusicDialogGroup
          groupId={group.id}
          mediaId={group.doc.music_on_hold.media_id}
          onComplete={handleOnComplete}
          onCancel={toggleShowEditDialog}
        />
      ) : null}
      <GenericSettingsCardField
        title={'Hold Music'}
        titleHelp={t('hold_music.tooltip')}
        chip={
          group.HoldMusic?.inherited ? (
            <Chip
              color={'primary'}
              variant={'contained'}
              label={startCase(group.HoldMusic.inherited)}
              size={'small'}
            />
          ) : !mediaId ? (
            <Chip
              color={'primary'}
              variant={'contained'}
              label={'Platform Default'}
              size={'small'}
            />
          ) : null
        }
        content={<AudioPlayer mediaId={mediaId ?? BUILT_IN_AUDIO[0].link} />}
        editOnClick={toggleShowEditDialog}
        editLabel={
          group.doc.music_on_hold.media_id
            ? 'Change Hold Music'
            : 'Add Hold Music'
        }
      />
    </div>
  );
};

export default GroupHoldMusic;
